import { ReactNode } from "react";
import Widget from "../../../commons/base/widget";
import SoScreen from "../../so/so_screen";
import FormButton from "../../../commons/ui/form_button";
import SoScreenViewModel from "../view_models/so_screen_view_model";
import SoScreenState from "../view_models/so_screen_state";

export default class LocationSelection extends Widget<{}, SoScreenState, SoScreenViewModel, SoScreen> {
    
    onButtonClick(locationId: number, locationName: string) {
        this.viewModel.emit((lastState) => {
            lastState.selectedLocationId = locationId;
            lastState.selectedLocation = locationName;
            return lastState;
        })
    }

    render(): ReactNode {
        return (
            <>
            {
                this.vmState.soLocations && this.vmState.soLocations.length > 0
                ? this.vmState.soLocations.map((loc, index) => {
                    return (
                        <div style={{display: "inline-block", margin: 10}} key={index}>
                            <FormButton
                            action={(e) => {
                                e.preventDefault();
                                this.onButtonClick(loc.locationId, loc.locationName)
                            }}
                            title={loc.locationName}
                            backgroundColor="#58BAD7"
                            textColor="#FFF"/>
                        </div>
                    )
                })
                : (
                    <FormButton
                        action={() => {}}
                        title="Tidak Ada Riwayat Dalam 7 Hari Terakhir"
                        backgroundColor="#58BAD7"
                        textColor="#FFF"/>
                )
            }   
            </>  
        )
    }
}